/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
function calculateShipping() {
  const regionSelect = document.getElementById('region');
  const shippingBox = document.getElementById('shipping-estimate');

  if (!regionSelect || !shippingBox) return;

    const shippingPrices = {
      i: 7900,      // Tarapacá
      ii: 7900,     // Antofagasta
      iii: 6900,    // Atacama
      iv: 5900,     // Coquimbo
      v: 4900,      // Valparaíso
      vi: 4900,     // O’Higgins
      vii: 5900,    // Maule
      viii: 5900,   // Biobío
      ix: 6900,     // La Araucanía
      x: 6900,      // Los Lagos
      xi: 7900,     // Aysén
      xii: 8900     // Magallanes
    };


  const region = regionSelect.value;
  const shippingCostBase = shippingPrices[region] || 0;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const cartTotal = cart.total_price / 100;

      if (cartTotal === 0) {
        shippingBox.classList.add('hidden');
        return;
      }

      const shippingCost = cartTotal >= 150000 ? 0 : shippingCostBase;
      const totalWithShipping = cartTotal + shippingCost;

      shippingBox.classList.remove('hidden');
      document.querySelector('[data-subtotal]').textContent = `$${cartTotal.toLocaleString('es-CL')}`;
      document.querySelector('[data-shipping]').textContent = shippingCost === 0 ? '🎉 ¡Tu envío es gratis!' : `$${shippingCost.toLocaleString('es-CL')}`;
      document.querySelector('[data-total]').textContent = `$${totalWithShipping.toLocaleString('es-CL')}`;
    });
}

function attachShippingEstimator() {
  const regionSelect = document.getElementById('region');

  if (regionSelect && !regionSelect.dataset.listenerAttached) {
    regionSelect.addEventListener('change', (e) => {
      e.preventDefault(); // 🔒 Evita comportamiento de submit
      e.stopPropagation(); // 🔕 Evita conflictos con otros scripts
      calculateShipping();
    });
    regionSelect.dataset.listenerAttached = 'true';
  }
}

// Observa cambios en el cart drawer para volver a conectar eventos
function observeCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) {
    setTimeout(observeCartDrawer, 300);
    return;
  }

  const observer = new MutationObserver(() => {
    // Vuelve a enganchar el listener solo si #region aparece
    attachShippingEstimator();
  });

  observer.observe(drawer, { childList: true, subtree: true });

  // Intenta enganchar por primera vez si ya está cargado
  attachShippingEstimator();
}

document.addEventListener('DOMContentLoaded', observeCartDrawer);



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
